/**
 * Assumption that the input is repositoryPath and is of the format <username>/<repository>.
 * Note: repositoryPath cannot contain '/' and are replaced with '-'
 */
export default function extractUsername(repositoryPath = ''): string {
  return repositoryPath.replace(/\/(.*)$/, '');
}
